import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import type { UniformItem } from "~types/uniformItem";
import { useApi } from "../../../shared/api";
import type { FormType } from "../models/formModel";
import { transformUniformItemsResponse } from "../utilities/transformUniformItemsResponse";

const useFetchUniformItems = (uniformId?: string) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();
  const { uniforms } = useSportConfiguration();

  const fn = async (): Promise<{ uniformItems: UniformItem[]; transformedParts: FormType["uniformParts"] }> => {
    if (uniformId) {
      const url = `${sport}/o/${organizationId}/uniforms/${uniformId}/items`;
      const response = await fetchData({
        url: url,
      });

      const uniformItems: UniformItem[] = response.data ?? [];

      return {
        uniformItems,
        transformedParts: transformUniformItemsResponse(uniforms.items, uniformItems),
      };
    }

    return {
      uniformItems: [],
      transformedParts: {},
    };
  };

  return useQuery({
    queryKey: ["uniformItems", sport, organizationId, uniformId],
    queryFn: () => fn(),
  });
};

export default useFetchUniformItems;
